import i18n from 'i18next';
import React from 'react';
import { useHistory } from 'react-router-dom';
import useStyles from './ErrorPage.styles';
import { Button } from '../../common/components/buttons';

const ErrorPage = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.root}>
      <h2 className={classes.title}>{i18n.t('error.title')}</h2>
      <p className={classes.subTitle}>{i18n.t('error.subTitle')}</p>
      <div className={classes.buttonRow}>
        <Button primary type="button" onClick={() => history.goBack()}>
          {i18n.t('error.goBack')}
        </Button>
      </div>
      <p className={classes.message}>{i18n.t('error.message')}</p>
    </div>
  );
};

export default ErrorPage;
